import React from 'react';
import { TYPE_LABELS, TIER_LABELS } from '../constants';
import { ActionsMenu } from '../ActionsMenu';

export function AccountsTable({ accounts, onEdit, onServices, onBilling, onBank, onDeactivate, onDelete, onOpenPercentages }) {
    if (accounts.length === 0) {
        return (
            <div className="text-center py-5 text-white-50">
                <h6 className="m-0 opacity-50">No se encontraron cuentas para los filtros aplicados</h6>
            </div>
        );
    }

    return (
        <div className="modern-table-container">
            <table className="modern-table striped-table">
                <thead>
                    <tr>
                        <th>Cuenta</th>
                        <th>Tipo</th>
                        <th>Tier</th>
                        <th>Usuarios</th>
                        <th>Porcentajes</th>
                        <th>Estado</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {accounts.map((acc) => {
                        const items = [
                            { label: 'Editar', onClick: () => onEdit(acc) },
                            { label: 'Servicios', onClick: () => onServices(acc) },
                            { label: 'Datos de facturación', onClick: () => onBilling(acc) },
                            { label: 'Datos bancarios', onClick: () => onBank(acc) },
                        ];
                        if (acc.active === 1) {
                            items.push({ label: 'Desactivar', onClick: () => onDeactivate(acc) });
                        }
                        items.push({ label: 'Eliminar', danger: true, onClick: () => onDelete(acc) });
                        return (
                            <tr key={acc.id_pub}>
                                <td className="short fw-bold text-white">
                                    <span className="badge-status me-2">{acc.prefix}</span>
                                    {acc.pub_name}
                                </td>
                                <td className="short text-white-50">{TYPE_LABELS[acc.type] || acc.type}</td>
                                <td className="short text-white-50">{acc.account_tier ? (TIER_LABELS[acc.account_tier] || acc.account_tier) : '—'}</td>
                                <td className="short text-white-50">{acc.users_count}</td>
                                <td className="short">
                                    {acc.hired_services && acc.hired_services.dist === '1' ? (
                                        acc.percent_count > 0 ? (
                                            <span className="badge-status status-on">Configurados</span>
                                        ) : (
                                            <button
                                                type="button"
                                                className="badge-status status-off badge-btn"
                                                title="Configurar porcentajes de la cuenta"
                                                onClick={() => onOpenPercentages && onOpenPercentages(acc)}
                                            >
                                                Falta agregar %
                                            </button>
                                        )
                                    ) : (
                                        <span className="text-white-50">—</span>
                                    )}
                                </td>
                                <td className="short">
                                    <span className={`badge-status ${acc.active === 1 ? 'status-on' : 'status-off'}`}>
                                        {acc.active === 1 ? 'Activa' : 'Inactiva'}
                                    </span>
                                </td>
                                <td>
                                    <ActionsMenu items={items} title="Acciones de la cuenta" />
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}

export default AccountsTable;